/** Файлы товара поступления с API (files или legacy file). */

export const getSupplyProductImageFiles = (row) => {
  const files = row?.files ?? row?.file ?? [];
  return files.filter((f) => {
    const mime = (f.mime || "").toLowerCase();
    if (mime.startsWith("image/")) return true;
    const n = (f.name || "").toLowerCase();
    return /\.(jpe?g|png|gif|webp|bmp|svg)$/.test(n);
  });
};
